import React from 'react';
import CheckboxInput from 'swag-client-common/components/inputs/checkbox-input';
import { variables } from 'swag-client-common/styles/variables-js';
export const MakeApiDefaultPaymentMethodWidget = ({
  value,
  label,
  className,
  paymentMethod,
  prevPopup,
  card,
  isLabelStyle,
  onClick,
  apiDefaultCard
}) => /*#__PURE__*/React.createElement(CheckboxInput, {
  input: {
    value,
    name: 'APIDefault',
    onChange: () => onClick(paymentMethod, value, card, prevPopup, apiDefaultCard),
    onBlur: () => ({})
  },
  label: label,
  dataInput: "APIDefault",
  className: className,
  labelStyle: isLabelStyle && labelStyle,
  iconStyle: iconStyle
});
const labelStyle = {
  color: variables.brownishGrey,
  fontSize: '15px',
  letterSpacing: '0px',
  width: 'calc(100% - 50px)'
};
const iconStyle = {
  fill: variables.brownishGrey
};